import Markdown from "markdown-to-jsx/react";
import DOMPurify from "isomorphic-dompurify";
// import { IoLocationSharp } from "react-icons/io5";

// import StaticMap from "../../../../maps/StaticMap/StaticMap";

// import styles from "./OverviewSection.module.scss";

const OverviewSection = ({ experience }) => {
  const { metadata, location, overview } = experience;
  const { description, impact } = overview;
  // const { lngLat, countries, cities } = location;
  // const { lng, lat, zoom } = lngLat;

  return (
    <>
      <Markdown>{DOMPurify.sanitize(description)}</Markdown>
      <h3 style={{ marginTop: "15px" }}>Objectives</h3>
      <Markdown>{DOMPurify.sanitize(impact)}</Markdown>
    </>
  );
};

export default OverviewSection;
